import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IPauseCampaignPayload } from '@app-store/slices/campaigns/pauseCampaign'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IPauseCampaignPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.campaigns.pauseCampaign
const { onChangeStatus } = rootActions.campaigns.eventCampaignList

function* pauseCampaignSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/notifications/campaigns/pause/${payload.campaignId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(payload?.sagaCB?.onSucccess())
            yield put(onChangeStatus({ campaignId: payload.campaignId, status: 'Ongoig' }))
            notification.success({
                message: 'Campaign published successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* pauseCampaignSaga(): any {
    yield takeLatest<TaskAction>(onRequest, pauseCampaignSagaTask)
}

export default pauseCampaignSaga
